import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  EXW: [],
};

const EXWSlice = createSlice({
  name: "EXW",
  initialState,
  reducers: {
    updateEXW: (state, action) => {
      const index = state.EXW.findIndex(
        (item) => item.country === action.payload.country
      );
      if (index !== -1) {
        state.EXW[index] = action.payload;
      } else {
        state.EXW.push(action.payload);
      }
    },
  },
});

export const { updateEXW } = EXWSlice.actions;

export default EXWSlice.reducer;
